<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<div id="content" class="app-content box-shadow-3 scroll-x">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-light bg-white b-b">
					<a class="navbar-brand">Landing</a>
				</div>

				<div class="content-main">
					<div class="padding text-center h-100 d-flex flex-column">
						<h1 class="text-muted _600 mb-4">
							{{ user.first_name }} {{ user.last_name }} ({{ user.email }})
						</h1>
						<h2 class="text-muted mb-4">
							Welcome to
							<span class="text-theme">{{ brand.name }}™</span>
						</h2>
						<div
							class="flex row m-0 justify-content-center mx-auto"
							style="max-width: 900px; max-height: 900px;"
						>
							<div
								v-if="user.role.teacher_entry"
								class="padding col-12 col-sm-6"
								style="max-width: 450px; max-height: 450px;"
							>
								<a
									class="h-100 d-flex flex-column justify-content-center align-items-center card hover-darken"
									style="padding: 1rem;"
									href="/#/classes"
								>
									<img src="@/assets/images/classes.png" alt="Classes" style="max-width: 150px;" />
									<h3 class="text-muted mt-4 mb-0">Manage My Classes</h3>
								</a>
							</div>
							<div
								v-if="user.role.scorer_entry"
								class="padding col-12 col-sm-6"
								style="max-width: 450px; max-height: 450px;"
							>
								<a
									class="h-100 d-flex flex-column justify-content-center align-items-center card hover-darken"
									style="padding: 1rem;"
									href="/#/scoring"
								>
									<img src="@/assets/images/scoring.png" alt="Scoring" style="max-width: 150px;" />
									<h3 class="text-muted mt-4 mb-0">Second/Resolution Score</h3>
								</a>
							</div>
							<div
								v-if="user.role.reporting_entry"
								class="padding col-12 col-sm-6"
								style="max-width: 450px; max-height: 450px;"
							>
								<a
									class="h-100 d-flex flex-column justify-content-center align-items-center card hover-darken"
									style="padding: 1rem;"
									href="/#/reporting"
								>
									<img
										src="@/assets/images/reporting.png"
										alt="Reporting"
										style="max-width: 150px;"
									/>
									<h3 class="text-muted mt-4 mb-0">View Reports</h3>
								</a>
							</div>
							<div
								v-if="user.role.admin_entry"
								class="padding col-12 col-sm-6"
								style="max-width: 450px; max-height: 450px;"
							>
								<a
									class="h-100 d-flex flex-column justify-content-center align-items-center card hover-darken"
									style="padding: 1rem;"
									href="/#/config"
								>
									<img src="@/assets/images/config.png" alt="Config" style="max-width: 150px;" />
									<h3 class="text-muted mt-4 mb-0">Configure System</h3>
								</a>
							</div>
							<div
								v-if="user.role.teacher_entry && user.role.page_create_from_template"
								class="padding col-12 col-sm-6"
								style="max-width: 450px; max-height: 450px;"
							>
								<a
									class="h-100 d-flex flex-column justify-content-center align-items-center card hover-darken"
									style="padding: 1rem;"
									href="/#/myassessments"
								>
									<img src="@/assets/images/myassessments.png" alt="Assessments" style="max-width: 150px;" />
									<h3 class="text-muted mt-4 mb-0">My Assessments</h3>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
</style>

<script>
import BrandService from "@/services/BrandService";
var brand = BrandService.getBrand();

export default {
	name: "Landing",

	props: ["user"],

	data() {
		return {
			brand: brand
		};
	},
	components: {},
	created() {},
	methods: {}
};
</script>





// WEBPACK FOOTER //
// src/vues/Landing/Landing.vue